import { render } from "./ArrowRight.vue?vue&type=template&id=0f53957c&scoped=true"
const script = {}

import "./ArrowRight.vue?vue&type=style&index=0&id=0f53957c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f53957c"]])

export default __exports__